import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';
import { GlobalConstants } from 'src/app/base/global.constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import {
  getAllQueries,
  getQBFields,
  getQBQueries,
  saveQBQueries,
  setAllQueries,
  setQBFields,
  setQBQueries
} from '../actions/queryBuilder.actions';

@Injectable()
export class QueryBuilderEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);

  getQBFields = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getQBFields),
        map((action) => {
          if (action.apiConstants?.currentTable && action.apiConstants?.appUser && action.apiConstants?.roles) {
            return combineLatest([
              this.baseService[action.apiConstants?.currentTable.method](action.apiConstants?.currentTable),
              this.baseService[action.apiConstants?.appUser.method](action.apiConstants.appUser),
              this.baseService[action.apiConstants?.roles.method](
                action.apiConstants?.roles,
                GlobalConstants.dataTableHeaders
              )
            ]).subscribe((res: any) => {
              this.store.dispatch(setQBFields({ qbFields: res }));
            });
          } else if (action.apiConstants?.currentTable && action.apiConstants?.appUser && !action.apiConstants?.roles) {
            return combineLatest([
              this.baseService[action.apiConstants?.currentTable.method](action.apiConstants?.currentTable),
              this.baseService[action.apiConstants?.appUser.method](action.apiConstants.appUser)
            ]).subscribe((res: any) => {
              this.store.dispatch(setQBFields({ qbFields: res }));
            });
          } else if (
            action.apiConstants?.currentTable &&
            !action.apiConstants?.appUser &&
            !action.apiConstants?.roles
          ) {
            return combineLatest([
              this.baseService[action.apiConstants?.currentTable.method](action.apiConstants?.currentTable)
            ]).subscribe((res: any) => {
              this.store.dispatch(setQBFields({ qbFields: res }));
            });
          }
          return combineLatest([
            this.baseService[action.apiConstants?.appUser.method](action.apiConstants.appUser),
            this.baseService[action.apiConstants?.currentTable.method](action.apiConstants?.currentTable),
            this.baseService[action.apiConstants?.roles.method](
              action.apiConstants?.roles,
              GlobalConstants.dataTableHeaders
            )
          ]).subscribe((res: any) => {
            this.store.dispatch(setQBFields({ qbFields: res }));
          });
        })
      ),
    { dispatch: false }
  );

  getQBQueries = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getQBQueries),
        map((action) =>
          this.baseService[action.apiConstants?.method](action.apiConstants, action.params).subscribe(
            (qbQueries: any) => {
              this.store.dispatch(setQBQueries({ qbQueries }));
            }
          )
        )
      ),
    { dispatch: false }
  );

  saveQBQueries = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveQBQueries),
        map((action) => {
          console.log('Save Queries', action);
          this.baseService[action.apiConstants?.method](action.apiConstants, action.queryObject).subscribe(
            (qbObject: any) => {
              console.log(qbObject);
            }
          );
        })
      ),
    { dispatch: false }
  );

  getAllQueries = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getAllQueries),
        map((action) =>
          this.baseService[action.apiConstants?.method](action.apiConstants).subscribe((allQueries: any) => {
            this.store.dispatch(setAllQueries({ allQueries }));
          })
        )
      ),
    { dispatch: false }
  );
}
